export const SET_LOG = (log: any) => {
    if (window.location.hostname.includes('localhost')) {
        console.log(log);
    }
}